export default __webpack_public_path__ + "static/media/about-affiliates-Grey.20483c7a.svg";